import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './component/MainLayout';
import Event from './component/Event';
import TopBar from './component/TopBar';
import './styles/sass/style.scss';
import Video from './component/Video';
import Community from './component/Community';
import ContactUs from './component/ContactUs';
import EventShow from './component/EventShow';

const App = () => {
  return (
    <Router>
      <TopBar /> {/* Always visible on all pages */}
      <Routes>
        <Route path="/" element={<MainLayout />} />
        <Route path="/event" element={<Event />} />
        <Route path="/event/details" element={<EventShow />} />
        <Route path="/video" element={<Video />} />
        <Route path="/community" element={<Community />} />
        <Route path="/contact" element={<ContactUs />} />
        {/* Add other routes here */}
      </Routes>
    </Router>
  );
};

export default App;
